import { http, lHttp } from '@utils/interceptor'
import { ActionContext, Module } from 'vuex'
import { getSelectedCityId, isRkhy, uid, skey } from '@utils/index'
import { localStore } from '@utils/storage'
import { includes, isString } from 'lodash'
import { City } from '@/app/core/constant'
import { mapToList } from '@/app/core/utils/helper'
// import qs from 'qs'
import queryString from 'query-string'

const api = {
  hotSearchApi: '//cms.cekid.com/publish/890/search_hot_keywords.json',
  rankSearchApi: '//soperationapi.czj100.com/soperation-api/ads/hotSearchList.do',
  searchResultApi: `${process.env.NODE_ENV === 'production' ? '//svsesapi.cekid.com/' : ''}/svses-api/api/queryAggregate.do`,
  queryTotalApi: '//svsesapi.haiziwang.com/svses-api/api/queryTotal.do',
  createForm: '//svsactivity.haiziwang.com/svshd-web/appcustom/autoAddWorkerIntention.do'
  // createForm: '/svshd-web/appcustom/autoAddWorkerIntention.do'
}

export enum RequestType {
  RequestAll = 1,
  RequestBuiness = 2,
  RequestProduct = 3,
  RequestMatron = 4,
  RequestConsultant = 5,
  RequestThirdPartScenic = 6,
  RequestStudy = 7,
  RequestHotel = 8
}

export interface SearchTotalRequest {
  cityId?: string
  keyWords?: string
  tabs?: string
  longLatitude?: string //经纬度，维度在前，经度在后
  position?: any
}
interface SearchResultRequest {
  type: RequestType //搜索类型（1-全部 2-商家 3-商品）
  openOption?: boolean //是否开启筛选功能
  keyWords?: string
  tabs?: string
  start: number
  limit?: number
  cityId?: string
  districtId?: string //区ID
  longLatitude?: string //经纬度，维度在前，经度在后
  query?: string //产后康复专用
  distanceSort?: boolean
  distance?: string
  saleNumSort?: boolean
  storeFavPersonNumSort?: boolean
  level4CategoryId?: string | string[]
  position?: any
  starLevel?: string
  lightExperience?: string
  storeCode?: string
  isSelf?: number // 是否自营（1:自营，2:联营）
  isShowHideSpu?: number //前台展示"为否"的商品 默认是0
  spotCityId?: string | number //携程专用
  defaultSort?: boolean
  researchType?: string | number //研学类型
  themeType?: string | number //研学主题
  directionTypes?: string[]
  ageFilter? : string | number
}

export interface BaseResponse<T> {
  code: string
  data: T
  msg: string
}

interface SearchResultResponse {
  businessInfo: SearchInfo
  cmmdtyInfo: SearchInfo
  maternityInfo: SearchInfo
  adviserInfo: SearchInfo
  spotInfo: SearchInfo
  categoryInfo: CategoryList[]
  esTagResp: any
  researchStudy: SearchInfo
  hotelInfo: SearchInfo
}

interface SearchTotalResponse {
  total: number
  type: number //类型（2：商家 3：商品 4:月嫂 5：育儿顾问）
}

//商家info
interface SearchInfo {
  total: number
  list: any[]
  levelInfo: LevelBean[]
  experienceInfo: BrightBean[]
  storeInfo: StoreBean[]
}

export interface CategoryBean {
  title?: string
  id?: string
  categoryId?: string
}

export interface CategoryList {
  title: string
  id?: string
  list: CategoryBean[]
}

export interface DistrictBean {
  ID: string
  NAME: string
}

export interface LevelBean {
  starLevel?: string
  starLevelName?: string
  ID?: string
  NAME?: string
}

export interface BrightBean {
  lightExperience?: string
  lightExperienceName?: string
  ID?: string
  NAME?: string
}

export interface StoreBean {
  storeCode?: string
  storeName?: string
  ID?: string
  NAME?: string
}

export async function getSearchResult(req: SearchResultRequest): Promise<BaseResponse<SearchResultResponse>> {
  const cityId = getSelectedCityId()
  const { level4CategoryId, position } = req
  if (level4CategoryId && isString(level4CategoryId)) {
    req.level4CategoryId = level4CategoryId.split(',')
  } else {
    delete req.level4CategoryId
  }
  if (!req.query) delete req.query
  if (!req.districtId) delete req.districtId
  if (position && position.lng && position.lat) {
    req.longLatitude = `${position.lat},${position.lng}`
  }
  delete req.position
  if (isRkhy() || queryString.parseUrl(location.href).query.shareEarn) {
    req.isShowHideSpu = 1
  }
  return http.post(api.searchResultApi, { ...req, cityId, uid, skey })
}

export async function getQueryTotal(req: SearchTotalRequest): Promise<BaseResponse<SearchTotalResponse>> {
  const cityId = getSelectedCityId()
  const { position } = req
  if (!req.keyWords) delete req.keyWords
  if (!req.tabs) delete req.tabs
  if (!req.position) delete req.longLatitude

  if (position && position.lng && position.lat) {
    req.longLatitude = `${position.lat},${position.lng}`
  }
  delete req.position

  return http.post(api.queryTotalApi, { ...req, cityId, tabs: '2,4' })
}

export const KSearchHistory_Key = 'course.search.history'

export async function getCMS(par: any): Promise<any> {
  const res = http.get(api.hotSearchApi, {
    params: par
  })
  return res
}
interface SearchHistoryData {
  keyword: string
}
export function getSearchHistroy() {
  const ls = localStore.getItem(KSearchHistory_Key)
  const lsj = JSON.parse(ls || '[]')
  return lsj
}

interface SearchHotData {
  keyword: string
}
export async function getSearchHot(): Promise<SearchHotData[]> {
  const response: ResponseCode = await http.get(api.hotSearchApi)
  if (response && response.code == '0' && response.data && response.data.search) {
    return response.data.search
  } else {
    return []
  }
}

interface SearchRankData {
  spuId: string
  link: string
  title: string
  popularity: string
}
export async function getSearchRank(): Promise<SearchRankData[]> {
  const siteCode = getSelectedCityId() //城市编码
  const response: ResponseErrno = await http.get(api.rankSearchApi, {
    params: { citycode: siteCode }
  })
  if (response && response.errno == '0' && response.data) {
    return response.data
  } else {
    return []
  }
}

interface FormData {
  uid: string
  skey: string
  cityId: string | number
  cityName: string
  createTime: string
  content: string
  categoryId: Array<string>
  utm: string
}

export async function createNeedFormService(param: FormData): Promise<BaseResponse<null>> {
  Object.keys(param).forEach(i => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof param[i] === 'object') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      param[i] = JSON.stringify(param[i])
    }
  })
  const qs = queryString.stringify(param)
  const response = await http.post(api.createForm, qs)
  return response
}
interface SearchState {
  searchRecords: SearchHistoryData[] //搜索记录
}
export const SEARCH_STORE: Module<SearchState, any> = {
  namespaced: true,
  state: () => ({
    searchRecords: getSearchHistroy()
  }),
  mutations: {
    setSearchRecords(state: SearchState, payload: any) {
      state.searchRecords = payload
    }
  },
  getters: {},
  actions: {
    addSearchRecords(context: ActionContext<SearchState, any>, keyword: string) {
      if (keyword.trim() === '') {
        return false
      }

      const ls = localStore.getItem(KSearchHistory_Key)
      const lsj = JSON.parse(ls || '[]')

      let idx = -1
      lsj.forEach((item: SearchHistoryData, index: number, arr: Array<SearchHistoryData>) => {
        if (item.keyword === keyword) idx = index
        return false
      })
      if (idx !== -1) {
        lsj.splice(idx, 1)
      }
      lsj.unshift({
        keyword
      })

      const lss = JSON.stringify(lsj)
      localStore.setItem(KSearchHistory_Key, lss)
      context.commit('setSearchRecords', lsj)
    },

    clearSearchRecords(context: ActionContext<SearchState, any>) {
      localStore.removeItem(KSearchHistory_Key)
      context.commit('setSearchRecords', [])
    }
  }
}

//搜索模块vuex
interface SearchResState {
  location: any | null
  selectCity: City | null
  categoryList: CategoryList[] //品类列表
  districtList: DistrictBean[]
  levelList: LevelBean[]
  bRightList: BrightBean[]
  storeList: StoreBean[]
  businessCategorySelect: CategoryBean | null //商家筛选选中品类
  productCategorySelect: CategoryBean | null //商品筛选选中品类
  businessDistrictSelect: DistrictBean
  productDistrictSelect: DistrictBean
  yueSaoDistrictSelect: DistrictBean
  yueSaoLevelSelect: LevelBean
  yueSaoBrightSelect: BrightBean
  yuerStoreSelect: StoreBean
  businessDistanceSort: boolean
  businessGoodCommentSort: boolean
  productDistanceSort: boolean
  productSalesSort: boolean
  productDefaultSort: boolean
  yuerDistanceSort: boolean
  yuerGoodCommentsSort: boolean
  businessNum: number | null
  productNum: number | null
  yueSaoNum: number | null
  yuerNum: number | null
  hotelNum: number | null
  researchStudyNum: number | null
  thirdPartScenicNum: number | null
  thirdPartScenicScreen: string[]
  hotelSortInfo: any
  studySortInfo: any
  studySelf: boolean

  researchTypes: any[]
  researchThemes: any[]
  researchAgeTypes: any[]
  researchDirections: any[]
  studyTypeInfo: any
  studyThemeInfo: any
  studyAgeTypeInfo: any
  studyDirection: any[]
}

export const SEARCHRES_STORE: Module<SearchResState, any> = {
  namespaced: true,
  state: () => ({
    location: null, //地址信息
    selectCity: null,
    businessNum: null,
    productNum: null,
    yueSaoNum: null,
    yuerNum: null,
    researchStudyNum: null, //研学数量
    hotelNum: null, //酒店数量
    thirdPartScenicNum: null,
    districtList: [],
    categoryList: [{ title: '全部', list: [{ title: '全部' }] }],
    levelList: [],
    bRightList: [],
    storeList: [],
    businessCategorySelect: null,
    productCategorySelect: null,
    businessDistrictSelect: { ID: '', NAME: '全城' },
    productDistrictSelect: { ID: '', NAME: '全城' },
    yueSaoDistrictSelect: { ID: '', NAME: '全城' },
    yueSaoLevelSelect: { ID: '', starLevel: '', NAME: '等级', starLevelName: '等级' },
    yueSaoBrightSelect: { ID: '', lightExperience: '', NAME: '亮点经验', lightExperienceName: '亮点经验' },
    yuerStoreSelect: { ID: '', lightExperience: '', NAME: '门店', lightExperienceName: '门店' },
    businessDistanceSort: true,
    businessGoodCommentSort: false,
    productDistanceSort: false,
    productSalesSort: false,
    productDefaultSort: true,
    yuerDistanceSort: true,
    yuerGoodCommentsSort: false,
    thirdPartScenicScreen: [],
    hotelSortInfo: undefined,
    studySortInfo: undefined,
    researchTypes: [],
    researchThemes: [],
    researchAgeTypes: [],
    researchDirections: [],
    studyTypeInfo: undefined,
    studyThemeInfo: undefined,
    studyAgeTypeInfo: undefined,
    studyDirection: [],
    studySelf: false
  }),
  mutations: {
    setLocation(state: SearchResState, payload: any) {
      state.location = payload
    },
    setSelectCity(state: SearchResState, payload: any) {
      state.selectCity = payload
    },
    resetBusiness(state: SearchResState) {
      state.businessCategorySelect = null
      state.businessDistrictSelect = { ID: '', NAME: '全城' }
      state.businessDistanceSort = true
      state.businessGoodCommentSort = false
    },
    resetProduct(state: SearchResState) {
      state.productCategorySelect = null
      state.productDistrictSelect = { ID: '', NAME: '全城' }
      state.productDistanceSort = false
      state.productSalesSort = false
      state.productDefaultSort = true
    },
    resetHotel(state: SearchResState) {
      state.hotelSortInfo = undefined
    },
    resetStudy(state: SearchResState) {
      state.studySortInfo = undefined
      state.studyAgeTypeInfo = undefined
      state.studyThemeInfo = undefined
      state.studyTypeInfo = undefined
      state.studyDirection = []
      state.studySelf = false
    },
    resetYueSao(state: SearchResState) {
      state.yueSaoDistrictSelect = { ID: '', NAME: '全城' }
      state.yueSaoLevelSelect = { ID: '', starLevel: '', NAME: '等级', starLevelName: '等级' }
      state.yueSaoBrightSelect = { ID: '', lightExperience: '', NAME: '亮点经验', lightExperienceName: '亮点经验' }
    },
    resetYuer(state: SearchResState) {
      state.yuerDistanceSort = false
      state.yuerGoodCommentsSort = false
      state.yuerStoreSelect = { ID: '', storeCode: '', NAME: '门店', storeName: '门店' }
    },
    selectThirdPartScenicScreen(state: SearchResState, str: string) {
      if (includes(state.thirdPartScenicScreen, str)) {
        state.thirdPartScenicScreen = state.thirdPartScenicScreen.filter(x => x !== str)
      } else {
        state.thirdPartScenicScreen = [...state.thirdPartScenicScreen, str]
      }
    },
    selectHotelSortInfo(state: SearchResState, sort: any) {
      state.hotelSortInfo = sort
    },
    selectStudySortInfo(state: SearchResState, info: any) {
      state.studySortInfo = info
    },
    selectAgeTypeInfo(state: SearchResState, info: any) {
      state.studyAgeTypeInfo = info
    },
    selectTypeInfo(state: SearchResState, info: any) {
      state.studyTypeInfo = info
    },
    selectThemeInfo(state: SearchResState, info: any) {
      state.studyThemeInfo = info
    },
    selectDirection(state: SearchResState, i: any) {
      const isSelect = state.studyDirection.find(x => x == i)
      if (isSelect) {
        state.studyDirection = state.studyDirection.filter(x => x != i)
      } else {
        state.studyDirection.push(i)
      }
    },
    selectStudySelf(state: SearchResState, info: boolean) {
      state.studySelf = info
    },
    resetThirdPartScenic(state: SearchResState) {
      state.thirdPartScenicScreen = []
    },
    setBusinessNum(state: SearchResState, payload: number) {
      state.businessNum = payload
    },
    setProductNum(state: SearchResState, payload: number) {
      state.productNum = payload
    },
    setYueSaoNum(state: SearchResState, payload: number) {
      state.yueSaoNum = payload
    },
    setYuerNum(state: SearchResState, payload: number) {
      state.yuerNum = payload
    },
    setThirdPartScenicNum(state: SearchResState, payload: number) {
      state.thirdPartScenicNum = payload
    },
    setResearchStudyNum(state: SearchResState, payload: number) {
      state.researchStudyNum = payload
    },
    setHotelNum(state: SearchResState, payload: number) {
      state.hotelNum = payload
    },
    setBusinessCategorySelect(state: SearchResState, payload: any) {
      state.businessCategorySelect = payload
    },
    setProductCategorySelect(state: SearchResState, payload: any) {
      state.productCategorySelect = payload
    },
    setBusinessDistrictSelect(state: SearchResState, payload: any) {
      state.businessDistrictSelect = payload
    },
    setProductDistrictSelect(state: SearchResState, payload: any) {
      state.productDistrictSelect = payload
    },
    setYueSaoDistrictSelect(state: SearchResState, payload: any) {
      state.yueSaoDistrictSelect = payload
    },
    setYueSaoBrightSelect(state: SearchResState, payload: any) {
      state.yueSaoBrightSelect = payload
    },
    setYuerStoreSelect(state: SearchResState, payload: any) {
      state.yuerStoreSelect = payload
    },
    setBusinessDistanceSort(state: SearchResState, payload: any) {
      state.businessDistanceSort = payload
    },
    setBusinessGoodCommentSort(state: SearchResState, payload: any) {
      state.businessGoodCommentSort = payload
    },
    setProductDistanceSort(state: SearchResState, payload: any) {
      state.productDistanceSort = payload
    },
    setProductSalesSort(state: SearchResState, payload: any) {
      state.productSalesSort = payload
    },
    setProductDefaultSort(state: SearchResState, payload: any) {
      state.productDefaultSort = payload
    },
    setYueSaoLevelSelect(state: SearchResState, payload: any) {
      state.yueSaoLevelSelect = payload
    },
    setYuerDistanceSort(state: SearchResState, payload: any) {
      state.yuerDistanceSort = payload
    },
    setYuerGoodCommentsSort(state: SearchResState, payload: any) {
      state.yuerGoodCommentsSort = payload
    },
    setDistrictList(state: SearchResState, payload: any) {
      state.districtList = payload
    },
    setStoreList(state: SearchResState, payload: any) {
      const all = { ID: '', starLevel: '', NAME: '全部', starLevelName: '全部' }
      const newList = [
        all,
        ...payload.map((item: any) => {
          item.ID = item.storeCode
          item.NAME = item.storeName
          return item
        })
      ]
      state.storeList = newList
    },
    setLevelList(state: SearchResState, payload: any) {
      const all = { ID: '', starLevel: '', NAME: '全部', starLevelName: '全部' }
      const newList = [
        all,
        ...payload.map((item: any) => {
          item.ID = item.starLevel
          item.NAME = item.starLevelName
          return item
        })
      ]
      state.levelList = newList
    },
    setBrightList(state: SearchResState, payload: any) {
      const all = { ID: '', lightExperience: '', NAME: '全部', lightExperienceName: '全部' }
      const newList = [
        all,
        ...payload.map((item: any) => {
          item.ID = item.lightExperience
          item.NAME = item.lightExperienceName
          return item
        })
      ]
      state.bRightList = newList
    },
    setCategoryList(state: SearchResState, payload: CategoryList[]) {
      payload.forEach((item: CategoryList) => {
        const num = item.list.length % 4
        const needAddTranslate = num > 1 ? 4 - num : 0 //>1的情况需要加几条空数据 方便ui  justify-content: space-between显示
        for (let index = 0; index < needAddTranslate; index++) {
          item.list.push({})
        }
      })
      state.categoryList = [{ title: '全部', list: [{ title: '全部' }] }, ...payload]
    },
    setStudyScreen(state: SearchResState, payload: any) {
      const { ageType = {}, directions = {}, researchThemes = {}, researchType = {} } = payload
      state.researchAgeTypes = mapToList(ageType, { NAME: '默认', TRIP: '年龄', ID: '' })
      state.researchThemes = mapToList(researchThemes, { NAME: '默认', TRIP: '主题', ID: '' })
      state.researchTypes = mapToList(researchType, { NAME: '默认', TRIP: '类型', ID: '' })
      state.researchDirections = mapToList(directions)
    }
  },
  getters: {},
  actions: {
    async getDistrictListByCityCode(context: ActionContext<SearchResState, any>) {
      let { DistrictList = [] } = await http.get(`//address.cekid.com/addressview/GetDistrictList?cityId=${getSelectedCityId()}`)
      DistrictList = [{ ID: '', NAME: '全城' }, ...DistrictList]
      context.commit('setDistrictList', DistrictList)
    }
  }
}
